import { render, staticRenderFns } from "./GestionProveedor.vue?vue&type=template&id=003af001&"
import script from "./GestionProveedor.vue?vue&type=script&lang=js&"
export * from "./GestionProveedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports